import React from "react";
import { post } from "../../../controlers/global/ConfigRequest";
import { RESET_PASSWORD, SEND_OTP } from "../../../helperData/ApiAddress";
import { GlobalStateContext } from "../../../layouts/GlobalStates";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { normalizeFaNumbers } from "./../../../utils/methods";

export default function Login({ mode, setMode, phoneInit, setActiveTab }) {
    const { t } = useTranslation();
    // const [showForget, setShowForget] = React.useState(false);
    const [username, setUsername] = React.useState("");
    const [usernameErr, setUsernameErr] = React.useState("");
    const [password, setPassword] = React.useState("");
    const [passwordErr, setPasswordErr] = React.useState("");
    const [rememberMe, setRememberMe] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [resultErr, setResultErr] = React.useState("");
    const [phone, setPhone] = React.useState(phoneInit || "");
    const [phoneErr, setPhoneErr] = React.useState("");
    const [code, setCode] = React.useState("");
    const [otpTimer, setOtpTimer] = React.useState(0);
    const { auth, setAuth, setRefreshNewCount } =
        React.useContext(GlobalStateContext);
    const [newPassword, setNewPassword] = React.useState();
    const [reNewPassword, setReNewPassword] = React.useState();
    const [newPasswordErr, setNewPasswordErr] = React.useState();
    const [matchPassErr, setMatchPassErr] = React.useState();
    const [accessToken, setAccessToken] = React.useState();
    const [otpCode, setOtpCode] = React.useState();

    React.useEffect(() => {
        setPhone(phoneInit);
    }, [phoneInit]);

    React.useEffect(() => {
        setResultErr("");
    }, [mode]);

    // const otpUsernameHandle = (e)=>{
    //     var patt = new RegExp(/^\+?([0-9]*)$/);
    //     if(patt.test(e.target.value) || e.target.value === ''){
    //         setUsernameErr('');
    //         setUsername(e.target.value)
    //     }
    // }

    // const usernameHandle = (e) => {
    //     setUsernameErr('');
    //     setUsername(e.target.value)
    // }

    // const passwordHandle = (e) => {
    //     setPasswordErr('');
    //     setPassword(e.target.value)
    // }

    // const rememberMeHandle = () => {
    //     setRememberMe(!rememberMe);
    // }

    const handleChangePasswordOtp = () => {
        if (code.length === 4) {
            setMode(5);
        }
    };

    // const otpLoginHandle = () => {

    //     let hasErr = false;
    //     let phoneStr;
    //     if(phone[0] === '+'){
    //         phoneStr = phone;
    //     }else if(phone[0] === '0'){
    //         if(phone[1] !== "9"){
    //             setPhoneErr('شماره تلفن صحیح نیست.');
    //             hasErr = true;
    //         }
    //         if(phone.length !== 11){
    //             setPhoneErr('شماره تلفن صحیح نیست.');
    //             hasErr = true;
    //         }
    //         phoneStr = "+98" + phone.substr(1);
    //     }else{
    //         setPhoneErr('شماره تلفن صحیح نیست.');
    //         hasErr = true;
    //     }

    //     if(hasErr) return false;
    //     setLoading(true);
    //     setResultErr('');
    //     axios.post(LOGIN_ADDRESS, {username: phoneStr, password: code, grant_type: "password"}).then(r=>{

    //         setMode(5)

    //         setAccessToken(r.access_token)

    //         setLoading(false);

    //     }).catch(r=>{
    //         setLoading(false);
    //         setResultErr('نام کاربری یا کد تایید صحیح نیست');
    //     })
    // }

    // const loginHandle = () => {
    //     let hasErr = false;
    //     let phoneStr;
    //     if(username[0] === '0' && username[1] === "9"){
    //         phoneStr = "+98" + username.substr(1);
    //     }

    //     if(username.trim().length === 0){
    //         setUsernameErr('لطفا نام کاربری را وارد کنید');
    //         hasErr = true;
    //     }
    //     if(password.trim().length === 0){
    //         setPasswordErr('لطفا رمز عبور را وارد کنید');
    //         hasErr = true;
    //     }
    //     if(hasErr) return false;
    //     setLoading(true);
    //     setResultErr('');
    //     post(LOGIN_ADDRESS, {username: phoneStr || username, password, grant_type: "password"}).then(r=>{

    //         if(rememberMe)
    //             window.localStorage.refresh_token = r.refresh_token;

    //         window.sessionStorage.auth = r.access_token;
    //         window.sessionStorage.id = r.user.id;
    //         window.sessionStorage.username = r.user.username;
    //         window.sessionStorage.usertype = r.user.user_level;
    //         window.sessionStorage.usercompany = r.user.company;
    //         setRefreshNewCount(prevState => !prevState)

    //         setAuth({...auth , id:r.user.id, access_token: r.access_token, username: r.user.username, usertype: r.user.user_level, usercompany: r.user.company})
    //         setLoading(false);
    //     }).catch(r=>{
    //         setLoading(false);
    //         setResultErr('نام کاربری یا رمز عبور صحیح نیست');
    //     })
    // }

    const codeTabHandle = (e) => {
        if (e.which === 8 && e.target.value === "") {
            e.target.previousElementSibling?.focus();
            e.target.previousElementSibling?.select();
        } else if (e.target.value.length === 1) {
            e.target.nextElementSibling?.focus();
            e.target.nextElementSibling?.select();
        }
    };
    const codeValueHandle = (e, index) => {
        let temp = [...code];
        if (e.target.value.length === 1) {
            temp[index] = normalizeFaNumbers(e.target.value);
        }
        if (e.target.value.length === 0) {
            temp[index] = "*";
        }
        setCode(temp.join(""));
    };

    const phoneHandle = (e) => {
        let patt = new RegExp(/^\+?([0-9]*)$/);
        if (patt.test(e.target.value) || e.target.value === "") {
            setPhoneErr("");
            setPhone(e.target.value);
        }
    };

    const sendOTPHandle = (e) => {
        let phoneStr;
        if (phone[0] === "+") {
            phoneStr = phone;
        } else if (phone[0] === "0") {
            if (phone[1] !== "9") {
                setPhoneErr(
                    t(
                        "Src.Component.Global.AuthModal.ChangePassword.setPhoneErr"
                    )
                );
                return false;
            }
            if (phone.length !== 11) {
                setPhoneErr(
                    t(
                        "Src.Component.Global.AuthModal.ChangePassword.setPhoneErr"
                    )
                );
                return false;
            }
            phoneStr = "+98" + phone.substr(1);
        } else {
            setPhoneErr(
                t("Src.Component.Global.AuthModal.ChangePassword.setPhoneErr")
            );
            return false;
        }
        setOtpTimer(120);
        post(SEND_OTP, { phone_number: phoneStr }).then((r) => {
            setOtpCode(r.code);
        });
    };

    const handleChangePassword = () => {
        let hasErr = false;

        let phoneStr = "+98" + phone.substr(1);

        if (reNewPassword === "") {
            setMatchPassErr(
                t(
                    "Src.Component.Global.AuthModal.ChangePassword.setMatchPassErr"
                )
            );
            hasErr = true;
        } else {
            setMatchPassErr("");
        }

        if (newPassword === "") {
            setNewPasswordErr(
                t(
                    "Src.Component.Global.AuthModal.ChangePassword.setNewPasswordErr"
                )
            );
            hasErr = true;
        } else {
            setNewPasswordErr("");
        }

        if (newPassword !== reNewPassword) {
            hasErr = true;
            setMatchPassErr(
                t(
                    "Src.Component.Global.AuthModal.ChangePassword.setMatchPassErrNotMatching"
                )
            );
        }

        if (hasErr) return false;
        setLoading(true);
        setResultErr("");
        axios
            .post(RESET_PASSWORD, {
                phone_number: phoneStr,
                password: newPassword,
                otp_code: code,
            })
            .then((r) => {
                // if(rememberMe)
                //     window.localStorage.refresh_token = r.refresh_token;

                // window.sessionStorage.auth = r.access_token;
                // window.sessionStorage.id = r.user.id;
                // window.sessionStorage.username = r.user.username;
                // window.sessionStorage.usertype = r.user.user_level;
                // window.sessionStorage.usercompany = r.user.company;
                // setAuth({...auth , id:r.user.id, access_token: r.access_token, username: r.user.username, usertype: r.user.user_level, usercompany: r.user.company})

                setActiveTab(1);
                setLoading(false);
            })
            .catch((r) => {
                setLoading(false);
                setResultErr(
                    t(
                        "Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.AddUser.EditUser.Danger"
                    )
                );
            });
    };

    React.useEffect(() => {
        if (otpTimer > 0)
            var timer = setTimeout(() => setOtpTimer(otpTimer - 1), 1000);
        return () => {
            clearTimeout(timer);
        };
    }, [otpTimer]);

    return (
        <div className="auth-scroll-body">
            {mode !== 5 && (
                <div>
                    <div className="forget-container">
                        <div className="input-form" style={{ marginBottom: 0 }}>
                            <div className="send-code-section">
                                <div className="ri-input">
                                    <label>
                                        {t("PhoneNumber.Place.Holder")}
                                    </label>
                                    <input
                                        type="tel"
                                        placeholder={t(
                                            "PhoneNumber.Hint.Place.Holder"
                                        )}
                                        value={phone}
                                        onChange={phoneHandle}
                                        readOnly={mode === 3}
                                        style={{
                                            borderColor: phoneErr && "orange",
                                            width: "100%",
                                        }}
                                    />
                                    {phoneErr && (
                                        <div
                                            className="login-form-err"
                                            style={{ height: 0, margin: 0 }}
                                        >
                                            {phoneErr}
                                        </div>
                                    )}
                                </div>
                                <button
                                    className="send-btn"
                                    disabled={otpTimer > 0}
                                    onClick={sendOTPHandle}
                                >
                                    {otpTimer > 0
                                        ? otpTimer + t("SendCode.Time.Button")
                                        : t("SendCode.Button")}
                                </button>
                            </div>

                            <div className="forget-numbers">
                                <input
                                    onKeyUp={codeTabHandle}
                                    value={code[0] === "*" ? "" : code[0]}
                                    onChange={(e) => codeValueHandle(e, 0)}
                                    placeholder="1"
                                />
                                <input
                                    onKeyUp={codeTabHandle}
                                    value={code[1] === "*" ? "" : code[1]}
                                    onChange={(e) => codeValueHandle(e, 1)}
                                    placeholder="2"
                                />
                                <input
                                    onKeyUp={codeTabHandle}
                                    value={code[2] === "*" ? "" : code[2]}
                                    onChange={(e) => codeValueHandle(e, 2)}
                                    placeholder="3"
                                />
                                <input
                                    onKeyUp={codeTabHandle}
                                    value={code[3] === "*" ? "" : code[3]}
                                    onChange={(e) => codeValueHandle(e, 3)}
                                    placeholder="4"
                                />
                                {/* <input
                                    onKeyUp={codeTabHandle}
                                    value={code[4] === "*" ? "" : code[4]}
                                    onChange={(e) => codeValueHandle(e, 4)}
                                    placeholder="5"
                                />
                                <input
                                    onKeyUp={codeTabHandle}
                                    value={code[5] === "*" ? "" : code[5]}
                                    onChange={(e) => codeValueHandle(e, 5)}
                                    placeholder="6"
                                /> */}
                            </div>
                            <div
                                className="check_btn login-check"
                                style={{ marginTop: 50 }}
                            ></div>
                        </div>
                        <div className="ri-btn">
                            <button
                                className="btn-st-1"
                                onClick={handleChangePasswordOtp}
                            >
                                {t("ChangePassword.Button")}
                            </button>
                            {(mode === 2 || mode === 4) && (
                                <button
                                    onClick={() => setMode(1)}
                                    className="btn-st-2"
                                >
                                    {t("SendCode.Back.Button")}
                                </button>
                            )}
                            {loading && (
                                <div className="login-form-notif">
                                    {t(
                                        "Src.Component.Global.AuthModal.ChangePassword.LoginFormNotif"
                                    )}
                                </div>
                            )}
                            {resultErr && (
                                <div className="login-form-err">
                                    {resultErr}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
            {mode === 5 && (
                <div>
                    <div className="forget-container">
                        <div className="input-form" style={{ marginBottom: 0 }}>
                            <div className="change-password-con">
                                <div className="ri-input">
                                    <label>{t("Login.NewPassword")}</label>
                                    <input
                                        type="password"
                                        placeholder=""
                                        value={newPassword}
                                        onChange={(e) =>
                                            setNewPassword(e.target.value)
                                        }
                                        readOnly={mode === 3}
                                        style={{
                                            borderColor:
                                                newPasswordErr && "orange",
                                        }}
                                    />
                                    {newPasswordErr && (
                                        <div
                                            className="login-form-err"
                                            style={{ height: 0, margin: 0 }}
                                        >
                                            {newPasswordErr}
                                        </div>
                                    )}
                                </div>
                                <div className="ri-input">
                                    <label>
                                        {t("Login.Repeat.NewPassword")}
                                    </label>
                                    <input
                                        type="password"
                                        placeholder=""
                                        value={reNewPassword}
                                        onChange={(e) =>
                                            setReNewPassword(e.target.value)
                                        }
                                        readOnly={mode === 3}
                                        style={{
                                            borderColor:
                                                matchPassErr && "orange",
                                        }}
                                    />
                                    {matchPassErr && (
                                        <div
                                            className="login-form-err"
                                            style={{ height: 0, margin: 0 }}
                                        >
                                            {matchPassErr}
                                        </div>
                                    )}
                                </div>
                                {(mode === 2 || mode === 4) && (
                                    <button
                                        className="send-btn"
                                        disabled={otpTimer > 0}
                                        onClick={sendOTPHandle}
                                    >
                                        {otpTimer > 0
                                            ? otpTimer +
                                              t("SendCode.Time.Button")
                                            : t("SendCode.Button")}
                                    </button>
                                )}
                            </div>
                        </div>
                        <div className="ri-btn">
                            <button
                                className="btn-st-1"
                                onClick={handleChangePassword}
                            >
                                {t(
                                    "Organizational.PointsManagment.PointsAllocation.Apply.Button"
                                )}
                            </button>
                            {(mode === 2 || mode === 4) && (
                                <button
                                    onClick={() => setMode(1)}
                                    className="btn-st-2"
                                >
                                    {t("Login.Enter.With.NewPassword")}
                                </button>
                            )}
                            {/* {
                                loading &&
                                <div className="login-form-notif">در حال ورود ...</div>
                                } */}
                            {resultErr && (
                                <div className="login-form-err">
                                    {resultErr}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
